<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Copy Fees Structure</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Standard</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
              item-text="standard" item-value="id" label="Standard" outlined persistent-hint
              hint="Please Select Standard" />
          </v-col>

          <v-col cols="12" sm="2" md="2" style="text-align: center;">
            <br>
            <br>
            <v-btn text color="#0f2027" :loading="loader">
              <v-icon large color="#0f2027">mdi-arrow-right-bold-circle</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="copy_to_ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col cols="12" sm="2">

            <p><v-icon color="error">*</v-icon><b>Standard</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="copy_to_standrad" :items="standard_list"
              item-text="standard" item-value="id" label="Standard" outlined persistent-hint
              hint="Please Select Standard" />
          </v-col>
          <!-- <v-col cols="12" sm="2">
                   <p><v-icon color="error">*</v-icon><b>Quota</b></p>
                     <v-autocomplete color="#0F2027" dense rounded required v-model="quota"  :items="quota_list" item-text="name" item-value="id" label="Quota" outlined 
                     persistent-hint hint="Please Select Quota"
                     />
                </v-col> -->
          <!-- <v-col cols="12" sm="2">
                   <p><v-icon color="error">*</v-icon><b>Installment</b></p>
                     <v-autocomplete color="#0F2027" dense rounded required v-model="installment"  :items="installment_list" item-text="name" item-value="id" label="Installment" outlined 
                     persistent-hint hint="Please Select Installment"
                     />
                </v-col> -->
          <!-- <v-col cols="12" sm="2"  v-if="new_admission_flag">
                  <br>
                <v-checkbox v-model="add_new_admision_fee_structure" label="Fee Structure For New Addmission"></v-checkbox>
                </v-col> -->
          <v-col cols="12" sm="1" v-if="ay && standard && copy_to_ay && copy_to_standrad">
            <br>
            <v-btn color="mb-2 button" @click="saveCopyFeesStructureData()" :loading="loader">Copy</v-btn>
          </v-col>
        </v-row>
        <!-- <hr v-if="this.showcomponent">
                <v-row justify="center" v-if="this.showcomponent">
                <v-col cols="12" sm="2">
                    <p class="padding-bot"><b>Prelim Date</b></p>
                    <input type="date" class="padding-bot" v-model="prelim_date" />
                </v-col>
                <v-col cols="12" sm="2">
                    <p class="padding-bot"><b>Relaxation Days</b></p>
                    <v-text-field class="padding-bot" @change="addToDueDate(this)" outlined dense v-model="relaxation_days"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                    <p class="padding-bot"><b>Due Date</b></p>
                    <input type="date" class="padding-bot" v-model="due_date" readonly />
                </v-col>
                <v-col cols="12" sm="2">
                    <p class="padding-bot"><b>Fine in Rs.</b></p>
                    <v-text-field class="padding-bot" outlined dense v-model="fine_in_rs"></v-text-field>
                </v-col>
            </v-row> -->



      </v-card>
      <v-card class="box" v-if="this.showcomponent && components.length > 0">
        <v-toolbar dense class="toolbar" flat color="white">
          <v-toolbar-title> Fees Components</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-col cols="12" sm="12" md="12">
          <v-simple-table class="elevation-1 mytable" dense v-if="components.length > 0" id="mytable1">
            <template>
              <thead color="#ffffcc">
                <tr>
                  <th class="text-left">Sr. No.</th>
                  <th class="text-left">Fees Components</th>
                  <th class="text-left">Amount In Rs.</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,i) in components" :key="item.id">
                  <td>{{i+1}}</td>
                  <td>{{item.name}}</td>
                  <td>
                    <input type="hidden" name="components_id" value="item.id" />
                    <!-- <v-text-field type="number" value="0" rounded class="padding-bot ml-2 pt-2" outlined dense v-model="item.amount" @change="addToSum(item.amount,item.id)"></v-text-field> -->
                    <v-text-field type="number" value="0" rounded class="padding-bot ml-2 pt-2" outlined dense
                      v-model="item.amount"></v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-card>
      <!-- <v-card class="box" v-if="show_copy_card">
       <v-toolbar flat dense class="toolbar" >
        <v-toolbar-title>Copy Fees Structure To</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
                <v-col cols="12" sm="2">
                    <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                     <v-autocomplete color="#0F2027" dense rounded required v-model="copy_to_ay"  :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined 
                     persistent-hint hint="Please Select Academic Year"
                     />
                </v-col>
                <v-col cols="12" sm="2">
                   <p><v-icon color="error">*</v-icon><b>Standard</b></p>
                     <v-autocomplete color="#0F2027" dense rounded required v-model="copy_to_standrad"  :items="standard_list" item-text="standard" item-value="id" label="Standard" outlined 
                     persistent-hint hint="Please Select Standard"
                     />
                </v-col>
                <v-col cols="12" sm="2">
                   <p><v-icon color="error">*</v-icon><b>Quota</b></p>
                     <v-autocomplete color="#0F2027" dense rounded required v-model="copy_to_quota"  :items="quota_list" item-text="name" item-value="id" label="Quota" outlined 
                     persistent-hint hint="Please Select Quota"
                     />
                </v-col>
                <v-col cols="12" sm="2">
                   <p><v-icon color="error">*</v-icon><b>Installment</b></p>
                     <v-autocomplete color="#0F2027" dense rounded required v-model="copy_to_installment"  :items="installment_list" item-text="name" item-value="id" label="Installment" outlined 
                     persistent-hint hint="Please Select Installment"
                     />
                </v-col>
                  <v-col cols="12" sm="1" v-if="copy_to_ay && copy_to_standrad && copy_to_quota && copy_to_installment">
                   <br>
                   <v-btn color="mb-2 button" @click="saveCopyFeesStructureData()" :loading="loader">Copy</v-btn>
                </v-col>
            </v-row>
       </v-card> -->

      <!-- <v-card class="box" v-if="query_list.length > 0">
     <v-data-table  :headers="headers" :items="query_list" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Queries</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
     </v-data-table>
 </v-card> -->
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      snackbar: false,
      overlay: false,
      ay_list:[],ay:"",standard_list:[],standrad:"",quota_list:[],quota:"",installment_list:[],installment:"",showcomponent:false,feesStructureInstallment:"",
      copy_to_ay:"",copy_to_standrad:"",copy_to_quota:"",copy_to_installment:"",
      components_value: [],
      components_id: [],components:[],show_copy_card:false, 
      //fine_in_rs: 0,relaxation_days: "",  prelim_date: "",due_date: "",new_admission_flag:null, add_new_admision_fee_structure:false,
    //   headers:[
    //   { text: "Title", value: "title" },
    //   { text: "Description", value: "description" },
    //   ],
  }),
   methods: {
    //  checkFlag() {
    //       // console.log(this.standard);
    //       let std = this.standard_list.find(element => element.id == this.standard);
    //       console.log('tag', std)
    //       this.new_admission_flag = std.is_new_admission_fee_applicable_logic
    // },
    saveCopyFeesStructureData(){
      //  for (var i = 0; i < this.components.length; i++) {
      //       this.components_id.push(this.components[i].id);
      //       this.components_value.push(this.components[i].amount);
      //     }
       const formData = {
              ay: this.copy_to_ay,
              standard: this.copy_to_standrad,
              academicyear:this.ay,
              std:this.standard
              // quota: this.copy_to_quota,
              // installment: this.copy_to_installment,
              // feesStructureInstallment:this.feesStructureInstallment,
              // components_value: this.components_value,
              // components_id: this.components_id,
          };
          this.loader=true
          axios
              .post("FeesStructureInstallment/saveCopyFeesStructureData", formData)
              .then((res) => {
                  if (res.data.flag == "YES") {
                     this.showSnackbar("green", "Fees Structure Copied Successfully");
                     this.loader=false
                  }
                    if (res.data.flag == "No") {
                       this.showSnackbar("#b71c1c", res.data.snackbar);
                  }
              })
              .catch((error) => {
                  window.console.log(error);
              })
              .finally(() => {
                  this.loader = false;
              });
      },
      fetchFeesStructureData() {
          const formData = {
              ay: this.ay,
              standard: this.standard,
              quota: this.quota,
              installment: this.installment,
          };
                axios
                    .post("FeesStructureInstallment/getInstallmentDetails", formData)
                    .then((res) => {
                        (this.showcomponent = false);
                        if (res.data.flag == "YES") {
                          if (res.data.isPresent == true) {
                             if (res.data.fees_structure_installment_details[0].components.length > 0) {
                                this.components = res.data.fees_structure_installment_details[0].components;
                              }
                              this.showcomponent = true;
                              this.loader = false;
                             (this.feesStructureInstallment = res.data.feesStructureInstallment);
                              this.relaxation_days = res.data.fees_structure_installment_details[0].relaxation_days;
                              this.fine_in_rs = res.data.fees_structure_installment_details[0].fine;
                              this.due_date = res.data.fees_structure_installment_details[0].due_date;
                              this.prelim_date = res.data.fees_structure_installment_details[0].prelim_due_date;
                            }else{
                              this.showSnackbar("#b71c1c", "No Fees  Structure Found..");
                            }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                        this.show_copy_card = true;
                    });
                return;
            },
     onLoad() {
      axios
        .post("FeesStructureInstallment/copyFeeStructureToAy")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.standard_list = res.data.standard_list;
            this.quota_list = res.data.quota_list;
            this.installment_list = res.data.installment_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>